import React, { useState, useContext } from "react";
import styles from "../Styles/Bulkmessage.module.css";
import { useForm } from "react-hook-form";
import { useCSVReader } from "react-papaparse";
import UserContext from "../context/UserContext";
import { VscMail } from "react-icons/vsc";
import { toast } from "react-toastify";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const EMAIL_SEND_DELAY = 10000;

function BulkEmailSender() {
  const { user } = useContext(UserContext);
  const { CSVReader } = useCSVReader();
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const sendEmail = async (email, title, message) => {
    try {
      const response = await fetch(`${API_BASE_URL}/app/whatsapp/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        body: JSON.stringify({ email: [email], title, message }),
      });

      if (!response.ok) throw new Error(`Failed to send to ${email}`);
      toast.success(`Sent to ${email}`, { position: "bottom-right", autoClose: 1000 });
    } catch (error) {
      toast.error(`Error sending to ${email}`, { position: "top-left" });
    }
  };

  const onSubmit = async (data) => {
    const { title, message } = data;

    if (emails.length === 0) {
      toast.error("Please upload a file with email addresses");
      return;
    }

    setLoading(true);
    setCurrentIndex(0);

    for (let i = 0; i < emails.length; i++) {
      setCurrentIndex(i + 1);
      await sendEmail(emails[i], title, message);
      await delay(EMAIL_SEND_DELAY);
    }

    toast.success("All emails sent", { position: "top-left" });
    setLoading(false);
    setCurrentIndex(0);
    reset();
    setEmails([]);
  };

  return (
    <div className={styles.messages}>
      <div className={styles.messages_content}>
        <div className={styles.header}>
          <span>
            <VscMail color="rgba(24, 20, 243, 1)" size={40} />
          </span>
          <p>Send messages to Registered Users.</p>
        </div>

        <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
          <div className={styles.input_field}>
            <CSVReader
              config={{ header: true }}
              onUploadAccepted={(results) => {
                const parsedEmails = results.data
                  .map((row) => row.email?.trim())
                  .filter(Boolean);
                setEmails(parsedEmails);
              }}
            >
              {({ getRootProps, acceptedFile, ProgressBar }) => (
                <>
                  <button
                    type="button"
                    {...getRootProps()}
                    className={styles.browseFile}
                  >
                    Upload Emails File (CSV)
                  </button>
                  {acceptedFile && (
                    <p className={styles.accepted_file}>Emails file uploaded</p>
                  )}
                  <ProgressBar style={styles.progressBarBackgroundColor} />
                </>
              )}
            </CSVReader>
          </div>

          <div className={styles.input_field}>
            <label>Subject</label>
            <input
              type="text"
              placeholder="Enter title here..."
              {...register("title", { required: "Title is required" })}
            />
            {errors.title && <p className={styles.error}>{errors.title.message}</p>}
          </div>

          <div className={styles.input_field}>
            <label>Message</label>
            <textarea
              placeholder="Enter message here..."
              rows={10}
              style={{ width: "100%" }}
              {...register("message", { required: "Message body is required" })}
            />
            {errors.message && (
              <p className={styles.error}>{errors.message.message}</p>
            )}
          </div>

          {/* Progress Indicator */}
          {loading && (
            <div className={styles.progressContainer}>
              <p>Sending {currentIndex} of {emails.length} emails...</p>
              <div className={styles.progressBarWrapper}>
                <div
                  className={styles.progressBar}
                  style={{
                    width: `${(currentIndex / emails.length) * 100}%`,
                  }}
                />
              </div>
            </div>
          )}

          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "Send Message"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default BulkEmailSender;
